import React from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";

const CompletePaymentModal = ({ orderPaySummary, completeBookingAndCollectPaymentModal, handleClose, changeCompletePaymentData, completePayment }) => {
    return (
        <Modal size="lg" show={completeBookingAndCollectPaymentModal} onHide={() => handleClose()} backdrop={"static"}>
            <Modal.Header>
                <Modal.Title>
                    <span>Complete Booking</span>
                </Modal.Title>
                <div style={{ fontSize: "12px", textAlign: "left", color: orderPaySummary?.isRequirePayment === false ? "blue" : "blue" }}>
                    <div>Gross Total UNPAID: ${orderPaySummary?.grossTotalUnpaid}</div>
                    <div>Gross Total PAID: ${orderPaySummary?.grossTotalPaid}</div>
                    <div>Require Payment ? {orderPaySummary?.isRequirePayment === false ? 'NO' : 'YES'}</div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div style={{ textAlign: "left", color: "green" }}>
                    <p>This serves as a checklist for completing the booking by capturing payment details etc., Details entered here are *internal only*</p>
                </div>
                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}
                    >
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Select Appointment End Date & Time <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="datetime-local"
                                placeholder="0"
                                aria-label="appointment end"
                                aria-describedby="basic-addon1"
                                onChange={e => changeCompletePaymentData("actualAppntEnd", e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group as={Row} controlId="formBookingId" style={{ display: "flex", justifyContent: "space-between", marginBottom: 15 }}>
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Total Duration (mins) <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                placeholder="Total Duration (mins)"
                                aria-label="total duration mins"
                                aria-describedby="basic-addon1"
                                onChange={(e) => changeCompletePaymentData("totalDurationMins", e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}
                    >
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Confirm patient created TBD account <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Form.Check
                                reverse
                                type="switch"
                                id="custom-switch"
                                aria-label="minutes spent"
                                aria-describedby="basic-addon1"
                                onChange={e => changeCompletePaymentData("ackPatientTbdAccCreated", e.target.value === "on" ? true : false)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}>
                        <Form.Label id="cardFormLabel" column sm={8}>
                            An amount of ${orderPaySummary?.grossTotalUnpaid} is unpaid. Confirm payment is collected ?
                            <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Form.Check
                                reverse
                                type="switch"
                                id="custom-switch"
                                aria-label="minutes spent"
                                aria-describedby="basic-addon1"
                                onChange={e => changeCompletePaymentData("ackPaymentCollected", e.target.value === "on" ? true : false)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group as={Row} controlId="formBookingId" style={{ display: "flex", justifyContent: "space-between", marginBottom: 15 }}>
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Collected payment amount? <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="number"
                                placeholder="Enter amount collected. e.g: 186.49"
                                aria-label="payment amount"
                                aria-describedby="basic-addon1"
                                onChange={(e) => changeCompletePaymentData("paymentAmount", e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}
                    >
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Reference ID <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                placeholder="Transaction id. Enter NA if not applicable."
                                aria-label="reference id"
                                aria-describedby="basic-addon1"
                                onChange={e => changeCompletePaymentData("paymentRefId", e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}
                    >
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Payment Method <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Form.Select className="p-2" onChange={e => changeCompletePaymentData("paymentMode", e.target.value)}>
                                <option>Customer Pay by link</option>
                                <option>Collect Payment page</option>
                                <option>Square Terminal</option>
                                <option>Customer Self check-in</option>
                            </Form.Select>
                        </Col>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group
                        as={Row}
                        controlId="formBookingId"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 15
                        }}
                    >
                        <Form.Label id="cardFormLabel" column sm={8}>
                            Close clinical service <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="textarea"
                                as="textarea"
                                row={3}
                                placeholder="Enter closing notes here"
                                aria-label="closing notes"
                                aria-describedby="basic-addon1"
                                onChange={e => changeCompletePaymentData("closingNotes", e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={completePayment}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CompletePaymentModal;
